module.exports = __webpack_public_path__ + "media/images/ellipse-3-bd8ec4683160299949a6129b411c5adc.svg";